import { Dialog } from '@chakra-ui/react';
import { ReactNode } from 'react';

import Spacer from 'shared_DEPRECATED/components/Spacer';

import { modal } from '.';
import { CloseButton } from '../Button/CloseButton';

type ModalHeaderProps = {
  children?: ReactNode | null;
  onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  shouldClose?: boolean;
};

export const ModalHeader = ({
  children = null,
  onClick,
  shouldClose = true,
}: ModalHeaderProps) => {
  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(evt);

    if (!shouldClose) {
      evt.preventDefault();
      return;
    }

    modal.close();
  };

  return (
    <>
      <Spacer size="zr lg zr zr">
        <Dialog.Header>{children}</Dialog.Header>
      </Spacer>
      <Dialog.CloseTrigger
        data-testid="modal-close"
        onClick={handleClick}
        asChild
      >
        <CloseButton />
      </Dialog.CloseTrigger>
    </>
  );
};
